import React, { useEffect } from 'react';
import Nftrarity from './components/Nftrarity';
import CharacterRaritySettings from './components/CharacterRaritySettings';
import PlanetDescription from './components/PlanetDescription';
import AOS from 'aos';
import 'aos/dist/aos.css';

const NftScarCity = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, []);

   useEffect(() => {
      AOS.init({
        duration: 1000, // animation duration
        once: false,    // 👈 allow animations to trigger on scroll up & down
        mirror: true,   // 👈 animate elements when scrolling past them
      });
  
      // optional: refresh on component updates
      AOS.refresh();
    }, []);

  return (
    <>
    <style>
      {`
        body {
          background: #040c1e;
        }
      `}
    </style>
      <Nftrarity />
      <CharacterRaritySettings />
      <PlanetDescription />
    </>
  );
};

export default NftScarCity;
